export enum AppRouter {
  DisplayNoneRoute,
  FloatingActionButtonRoute,
  SatisfactionRatingRoute,
  SatisfactionCESRatingRoute,
  FeedbackSectionRoute,
  BugReportFormRoute,
  QuestionSectionRoute,
  ThankYouSectionRoute,
  TabbedWidgetRoute,
  ConnectionErrorRoute,
  SurveyRoute,
  FeaturesFormRoute,
  TabbedWidgetRefreshRoute = -8,
  FloatingActionButtonRefreshRoute = -1,
}
